import React from "react";
import KuikaSkeleton from "../../ui-kit/kuika-skeleton/kuika-skeleton";

// Shimmer placeholders for the issue-detail content that streams in after the drawer opens
// (description, comments, activity). Each mirrors the real element's footprint so the content
// doesn't jump when it resolves. The bars are the shared ui-kit KuikaSkeleton primitive
// (which owns the shimmer + reduced-motion behaviour); this file only keeps the board's
// content-specific COMPOSITIONS. Bars are aria-hidden by the primitive; each wrapper carries
// role="status" with a label so assistive tech announces the load instead of reading empty space.

const LINE_HEIGHT: number = 11;

const DESC_LINES: readonly string[] = ["94%", "82%", "88%", "46%"];

export const DescriptionSkeleton: React.FC = () => (
  <div className="kuika-board__skel-desc" role="status" aria-label="Loading description">
    {DESC_LINES.map((width: string, index: number) => (
      <KuikaSkeleton key={`d${index}`} className="kuika-board__skel-line" width={width} height={LINE_HEIGHT} />
    ))}
  </div>
);

const COMMENT_BODY: readonly (readonly string[])[] = [
  ["32%", "90%", "62%"],
  ["26%", "74%"]
];

export const CommentsSkeleton: React.FC = () => (
  <div className="kuika-board__skel-comments" role="status" aria-label="Loading comments">
    {COMMENT_BODY.map((lines: readonly string[], index: number) => (
      <div key={`c${index}`} className="kuika-board__skel-comment">
        <KuikaSkeleton className="kuika-board__skel-avatar" width={24} height={24} />
        <div className="kuika-board__skel-comment-body">
          {lines.map((width: string, line: number) => (
            <KuikaSkeleton
              key={`c${index}-${line}`}
              className="kuika-board__skel-line"
              width={width}
              height={LINE_HEIGHT}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

const ACTIVITY_WIDTHS: readonly string[] = ["68%", "54%", "61%", "44%"];

export const ActivitySkeleton: React.FC = () => (
  <div className="kuika-board__skel-activity-list" role="status" aria-label="Loading history">
    {ACTIVITY_WIDTHS.map((width: string, index: number) => (
      <div key={`a${index}`} className="kuika-board__skel-activity">
        <KuikaSkeleton className="kuika-board__skel-avatar" width={22} height={22} />
        <KuikaSkeleton className="kuika-board__skel-line" width={width} height={LINE_HEIGHT} />
      </div>
    ))}
  </div>
);
